import client from '@stores/apollo'
import gql from 'graphql-tag'
import { IBookingImport } from '@api'
import { BookingImportFragment } from '@api/fragments'
import handleFetchResult from '@utils/handleFetchResult'

interface IPayload {
  node: IBookingImport
}

const mutateHandler = handleFetchResult<IPayload, IBookingImport>({
  handler: (data) => data.node,
  name: 'Summary',
})

export default function summary(id: string): Promise<IBookingImport> {
  return client.gql.query({ query, variables: { id } }).then(mutateHandler)
}

const query = gql`
  query node($id: ID!) {
    node(id: $id) {
      ... on BookingImport {
        ...BookingImportFragment
      }
    }
  }
  ${BookingImportFragment}
`
